<template>
  <div
    class="header-bottom sides-padding"
    :class="{ 'header-bottom__delimiter': !['home'].includes($route.name) }"
  >
    <div class="header-bottom__container container">
      <ul class="header-bottom__list">
        <li
          @mouseenter="handleHoverEnter(-1)"
          @mouseleave="$emit('hoverChange', null)"
          class="header-bottom__list-item"
        >
          <router-link
            :to="{ name: 'brands' }"
            class="header-bottom__link no-hover"
            :class="{
              'header-bottom__link--active': activeId === -1 && $store.state._overlays.categoriesOverlay,
            }"
          >
            Бренды
          </router-link>
        </li>

        <li
          @mouseenter="handleHoverEnter(item, i)"
          @mouseleave="handleHoverLeave"
          v-for="(item, i) in categories"
          :key="i"
          class="header-bottom__list-item"
          ref="subcategoryItem"
        >
          <router-link
            :to="{ name: 'catalog', params: { id: item.id } }"
            class="header-bottom__link no-hover"
            :class="{
              'header-bottom__link--active': activeId === item.id && $store.state._overlays.categoriesOverlay,
            }"
          >
            {{ item.title }}
          </router-link>
        </li>
      </ul>
      <HeaderSubcategoriesComponent
        v-for="item in categories"
        :key="item.id"
        :data="item"
        :active="active && active.id === item.id"
        :position="positions[item.id]"
      />
    </div>
  </div>
</template>

<script>
import HeaderSubcategoriesComponent from "components/header/components/HeaderSubcategoriesComponent.vue";

export default {
  name: "HeaderBottomComponent",
  components: { HeaderSubcategoriesComponent },
  props: {
    activeId: Number,
  },
  data() {
    return {
      active: null,
      positions: {},
    };
  },
  computed: {
    categories() {
      let categories = this.$store.state.categories || [];
      categories = categories.slice(0, 8);
      return categories;
    },
  },
  methods: {
    handleHoverEnter(item, i) {
      if (item === -1) {
        this.active = null;
        this.$emit("hoverChange", -1);
        return;
      }
      this.active = item;
      this.$emit("hoverChange", item.id);
      this.calculatePositions(item, i);
    },
    handleHoverLeave() {
      this.$emit("hoverChange", null);
    },
    calculatePositions(item, i) {
      const el = this.$refs.subcategoryItem[i];
      if (!el) {
        return;
      }

      // Get the parent container (the scrollable list)
      const parent = el.parentElement;

      // Get the parent's width
      const parentWidth = parent.offsetWidth; // or parent.clientWidth

      // Calculate the right offset (distance from the right edge of parent to right edge of element)
      let rightOffset = parentWidth - (el.offsetLeft + el.offsetWidth);
      if (rightOffset < 0) {
        rightOffset = 0;
      }

      // Get DOM measurements
      const rect = el.getBoundingClientRect(); // Element position relative to viewport
      const containerRect = this.$el.getBoundingClientRect(); // Header container
      const parentRect = parent.getBoundingClientRect(); // The scrollable list container

      // Get the scroll position of the parent container
      const parentScrollLeft = parent.scrollLeft;

      // Get the container's width dimensions
      const containerWidth = this.$el.clientWidth;

      // Determine which side of the viewport the element is on
      const viewportLine = window.innerWidth * 0.5;
      const isRightSide = rect.left > viewportLine;

      // Calculate the real-world position of the element
      // This makes the position "sticky" to the element regardless of scroll
      const dropdownLeft = el.offsetLeft;

      this.positions[item.id] = {
        // For the dropdown menu positioning
        // When element is on the right side, position dropdown on the left
        // When element is on the left side, position dropdown on the right
        left: isRightSide ? null : dropdownLeft - parentScrollLeft,
        right: isRightSide ? rightOffset : null,

        // Store additional data for debugging
        debug: {
          viewportBounds: {
            elementLeft: rect.left,
            elementRight: rect.right,
            containerLeft: containerRect.left,
            containerWidth: containerRect.width,
          },
          offsets: {
            elementOffsetLeft: el.offsetLeft,
            elementOffsetWidth: el.offsetWidth,
            parentScrollLeft: parentScrollLeft,
          },
        },
        isRightSide,
      };
    },
  },
};
</script>

<style lang="stylus">
.header-bottom {
  display flex
  justify-content center
  align-items center
  border-top 1px solid var(--gray-dark)
  background var(--white)
  position relative
  +below(860px) {
    display none
  }

  &__delimiter {
    border-bottom 1px solid var(--gray)
  }

  &__container {
    display inline-flex
    align-items center
		position relative
  }

  &__list {
    display inline-flex
    align-items center
    flex-shrink 0
    width 100%
    overflow-x auto
		overflow-y visible
		scrollbar-width: none
    position relative

    &-item {
			position: relative
      flex-shrink 0
      display flex
      align-items center
    }
  }

  &__link {
    padding 10px 20px 13px
    gap 4px
    display inline-flex
    align-items center
    font-weight: 700;
    line-height: 1.45
    color: var(--main-color-75)
    transition var(--transition)
    border-top 3px solid transparent

    &--active
    &:hover {
      color: var(--main-color)
      border-color var(--main-color)

      .icon svg path {
        fill var(--main-color)
      }
    }

    &-dropdown {
      position: absolute;
      top: 100%;
      left: 0
      right 0
      background: var(--white)
      box-shadow: 0 20px 30px var(--black_o15)
      opacity: 0;
      visibility: hidden;
      transition var(--transition)
      padding 20px
    }
  }
}
</style>
